// @ts-check

import Vue from 'vue'
import VueI18n from 'vue-i18n'

import locale from '@/configs/locale.js'

Vue.use(VueI18n)

// @ts-ignore
window.loadedLocales = []

const messages = {}
messages[locale.currentLocale] = require(/* webpackChunkName: "locale-[request]" */ '@/assets/locales/' + locale.currentLocale + '.js').default

const i18n = new VueI18n({
  locale: locale.currentLocale,
  messages: messages
})

export default i18n
